import React from 'react'
import Icon from '../Icon'
import { SkeletonDefaultProps } from './Skeleton.types'
import { StyledFlex } from './styled'

const Image: React.FC<SkeletonDefaultProps> = ({
  width = '96px',
  height = '96px',
  color,
  ...props
}) => {
  return (
    <StyledFlex
      height={height}
      width={width}
      backgroundColor={color}
      borderRadius='8px'
      justifyContent='center'
      alignItems='center'
      {...props}
    >
      <Icon name='Camera-solid' size='calc(100% - 32px)' color='black25' />
    </StyledFlex>
  )
}

export default Image
